// import React, { useState } from 'react';
// import './MembershipForm.css';
// import emailjs from '@emailjs/browser';

// const EMAILJS_SERVICE_ID = 'YOUR_SERVICE_ID';
// const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
// const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';

// const plans = ['Monthly', '3 Months', '6 Months', 'Annual', 'Not Sure Yet'];

// export default function MembershipForm({ onClose }) {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     plan: '',
//     message: '',
//   });
//   const [status, setStatus] = useState('idle'); // idle | loading | success | error

//   const handleChange = e =>
//     setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

//   const handleSubmit = async e => {
//     e.preventDefault();
//     setStatus('loading');
//     try {
//       await emailjs.send(
//         EMAILJS_SERVICE_ID,
//         EMAILJS_TEMPLATE_ID,
//         {
//           from_name: formData.name,
//           from_email: formData.email,
//           phone: formData.phone,
//           plan: formData.plan,
//           message: formData.message,
//           to_email: '1ms19cs146@gmail.com',
//         },
//         EMAILJS_PUBLIC_KEY
//       );
//       setStatus('success');
//     } catch (err) {
//       setStatus('error');
//     }
//   };

//   return (
//     <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
//       <div className="membership-form">
//         <button className="membership-form__close" onClick={onClose} aria-label="Close">
//           ✕
//         </button>

//         {status === 'success' ? (
//           <div className="membership-form__success">
//             <div className="membership-form__success-icon">✓</div>
//             <h3>Query Sent!</h3>
//             <p>We'll get back to you within 24 hours.</p>
//             <button className="membership-form__submit" onClick={onClose}>
//               Close
//             </button>
//           </div>
//         ) : (
//           <>
//             <div className="membership-form__header">
//               <p className="section-label">Get Started</p>
//               <h2 className="membership-form__title">
//                 Membership <span>Enquiry</span>
//               </h2>
//             </div>

//             <form onSubmit={handleSubmit} className="membership-form__body">
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Full Name *</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     placeholder="Your name"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Email Address *</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="your@email.com"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Phone Number</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     placeholder="+91 XXXXX XXXXX"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Membership Plan</label>
//                   <select name="plan" value={formData.plan} onChange={handleChange}>
//                     <option value="">Select a plan</option>
//                     {plans.map(p => (
//                       <option key={p} value={p}>{p}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label>Message / Query</label>
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   placeholder="Tell us about your fitness goals or any questions..."
//                   rows={4}
//                 />
//               </div>

//               {status === 'error' && (
//                 <p className="form-error">Something went wrong. Please try again or call us directly.</p>
//               )}

//               <button
//                 type="submit"
//                 className="membership-form__submit"
//                 disabled={status === 'loading'}
//               >
//                 {status === 'loading' ? 'Sending...' : 'Send Enquiry →'}
//               </button>
//             </form>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useState } from 'react';
import './MembershipForm.css';

const plans = ['Monthly', '3 Months', '6 Months', 'Annual', 'Not Sure Yet'];
const TO_EMAIL = 'gymarenaa163@gmail.com';

export default function MembershipForm({ onClose }) {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', plan: '', message: '',
  });
  const [status, setStatus] = useState('idle');

  const handleChange = e =>
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: '7925923c-3a2f-479e-a2fa-70a51539d0ac',
          subject: `Gym Arena Membership Enquiry from ${formData.name}`,
          from_name: formData.name,
          email: formData.email,
          phone: formData.phone,
          plan: formData.plan,
          message: formData.message,
          to: TO_EMAIL,
        }),
      });
      const data = await res.json();
      if (data.success) setStatus('success');
      else setStatus('error');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="membership-form">
        <button className="membership-form__close" onClick={onClose} aria-label="Close">
          ✕
        </button>

        {status === 'success' ? (
          <div className="membership-form__success">
            <div className="membership-form__success-icon">✓</div>
            <h3>Query Sent!</h3>
            <p>We will get back to you within 24 hours.</p>
            <button className="membership-form__submit" onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            <div className="membership-form__header">
              <p className="section-label">Get Started</p>
              <h2 className="membership-form__title">
                Membership <span>Enquiry</span>
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="membership-form__body">
              <div className="form-row">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text" name="name" value={formData.name}
                    onChange={handleChange} placeholder="Your name" required
                  />
                </div>
                <div className="form-group">
                  <label>Email Address *</label>
                  <input
                    type="email" name="email" value={formData.email}
                    onChange={handleChange} placeholder="your@email.com" required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel" name="phone" value={formData.phone}
                    onChange={handleChange} placeholder="+91 XXXXX XXXXX"
                  />
                </div>
                <div className="form-group">
                  <label>Membership Plan</label>
                  <select name="plan" value={formData.plan} onChange={handleChange}>
                    <option value="">Select a plan</option>
                    {plans.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Message / Query</label>
                <textarea
                  name="message" value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your fitness goals or any questions..."
                  rows={4}
                />
              </div>

              {status === 'error' && (
                <p className="form-error">Something went wrong. Please try again or call us directly.</p>
              )}

              <button
                type="submit"
                className="membership-form__submit"
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Sending...' : 'Send Enquiry'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}